import styled from 'styled-components';

const LoginTop = styled.div`
    background: #b4b4b4;
    padding: 15px 65px 5px;
    // border-radius: 20px 20px 0px 0px;
    text-align: center;
    color: #000;
`;

export default LoginTop;



// WEBPACK FOOTER //
// ./app/containers/Login/components/LoginTop/index.js